export const ApiStatics = {
  dashboard: {
    dashboard: "dashboard",
  },
  web: {
    web: "web",
    categories: "categories",
  },
  events: {
    event: "events",
    filter: "filter",
  },
  bookings: {
    bookings: "bookings",
    web: "web",
  },
  coupons: {
    coupons: "coupons",
    couponValidity: "coupons/:code/validity/public",
  },
};
